import { AxiosInstance } from 'axios';
import { responseHandler } from './response';
import {User, UserFormData} from '../../models/user';


export const updateProfile = async (client: AxiosInstance, user: UserFormData) =>
    responseHandler<User>(client.post(`/users/updateProfile`, user))

export const requestPasswordReset = async (client: AxiosInstance, email: string) =>
    responseHandler<void>(client.post(`/users/requestPasswordReset`, {email}), true)

export const resetPassword = async (
    client: AxiosInstance,
    body: { token: string, password: string, confirmPassword: string }
) => responseHandler<void>(client.post(`/users/resetPassword`, body), true)

export const verifyEmail = async (client: AxiosInstance, token: string) =>
    responseHandler<void>(client.post(`/users/verifyEmail`, {token}), true)

export const deleteAccount = async (client: AxiosInstance, body: { password?: string, confirmation?: string }) =>
    responseHandler<void>(client.post(`/users/deleteAccount`, body), true)

export const requestEmailVerification = async (client: AxiosInstance) =>
    responseHandler<void>(client.get(`/users/requestEmailVerification`), true)
